import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { SEO } from './components/layout/SEO';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Hero } from './components/landing/Hero';
import { ValueProps } from './components/landing/ValueProps';
import { TableOfContents } from './components/landing/TableOfContents';
import { AuthorBio } from './components/landing/AuthorBio';
import { Testimonials } from './components/landing/Testimonials';
import { PricingCTA } from './components/landing/PricingCTA';
import { NewsletterForm } from './components/landing/NewsletterForm';
import { CheckoutSuccess } from './components/checkout/CheckoutSuccess';
import { RedeemForm } from './components/redeem/RedeemForm';
import { AdminLogin } from './components/admin/AdminLogin';
import { Dashboard } from './components/admin/Dashboard';
import { CookieConsent } from './components/layout/CookieConsent';
import { Privacy } from './components/legal/Privacy';
import { Terms } from './components/legal/Terms';
import { Refund } from './components/legal/Refund';

const PlayPage = lazy(() =>
  import('./components/game/PlayPage').then((m) => ({ default: m.PlayPage })),
);

function LandingPage() {
  return (
    <>
      <SEO />
      <Header />
      <main>
        <Hero />
        <ValueProps />
        <TableOfContents />
        <AuthorBio />
        <Testimonials />
        <PricingCTA />
        <NewsletterForm />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/success" element={<CheckoutSuccess />} />
        <Route path="/redeem" element={<RedeemForm />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Dashboard />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund" element={<Refund />} />
        <Route
          path="/play"
          element={
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-text-light">Loading…</div>}>
              <PlayPage />
            </Suspense>
          }
        />
      </Routes>
      <CookieConsent />
    </>
  );
}
